<template>
    <div class="recordList" @scroll="handleScroll" ref="scrollContainer">
        <div v-if="total === 0 || activityData.length === 0" class="no-data">
            <div class="no-data-content">
                <div class="no-data-text">暂无领取记录</div>
            </div>
        </div>
        <div class="record" v-for="(item, index) in activityData" :key="index">
            <div class="itemRecord">
                <div style="display:flex;flex:1">
                    <div v-if="item.activityProductType === 60 || item.activityProductType === 30">
                        <img :src="`${picUrl}/${item.activityProductImgJSON.logoImages}`" class="logoImg"
                            v-if="item.activityProductImgJSON.logoImages"></img>
                        <img :src="`${picUrl}/${item.activityProductImg}`" class="logoImg" v-else>
                    </div>
                    <div v-if="item.activityProductType === 70">
                        <img src="../assets/amountGroup.png" class="logoImg"></img>
                    </div>
                    <div v-if="item.activityProductType === 90">
                        <img src="../assets/signIn/CreditScore.png" class="logoImg"></img>
                    </div>
                    <div class="nameList">
                        <div style="display:flex;align-items: center;">
                            <span class="name">{{ item.activityProductName }}{{ item.activityProductType === 70 ? '+' +
                                item.activityProductAmount / 100 + '元' : item.activityProductType
                                === 90 ? '+' + item.activityProductAmount + '分':'' }}</span>
                            <!-- 0是未发货 1是已发货 -->
                            <span class="status" v-if="item.deliveryStatus === 1">已发货</span>
                            <span class="status"
                                v-if="item.activityProductType === 70 && item.productStatus === 10">已发放</span>
                        </div>
                        <span class="date">领取时间：{{ item.gmtCreate }}</span>
                    </div>
                </div>
                <div>
                    <!-- 实物 -->
                    <div class="buts" type="primary"
                        v-if="item.userAddressId === '0' && item.activityProductType === 60"
                        @click="selectAddress(item)">选择地址</div>
                    <div class="buts" type="primary"
                        v-if="item.userAddressId != '0' && item.activityProductType === 60 && item.deliveryStatus === 0"
                        @click="selectAddress(item)">修改地址</div>
                    <div class="buts" style="font-size:11px;"
                        v-if="item.deliveryStatus === 1 && item.activityProductType === 60" @click="checkList(item)">
                        查看快递信息</div>
                    <!-- 实物 -->
                    <!-- 优惠券 -->
                    <div type="primary" v-if="item.activityProductType === 30 && item.productStatus === 20" class="buts"
                        @click="checkPoupon(item)">
                        查看</div>
                    <div style="font-size: 14px;color: #17C2CF;"
                        v-if="item.activityProductType === 30 && item.productStatus === 10">
                        已使用</div>
                    <!-- 优惠券 -->
                    <!-- 现金===70 -->
                    <div type="primary" v-if="item.activityProductType === 70 && item.productStatus === 20" class="buts"
                        @click="amountWithdrawal(item)">兑换</div>
                    <div type="primary" v-if="item.activityProductType === 70 && item.productStatus === 10" class="buts"
                        @click="goWithdrawal()">提现</div>
                    <!-- 现金 -->
                    <!-- 90 信誉分 -->
                    <div type="primary" v-if="item.activityProductType === 90 && item.productStatus === 20" class="buts"
                        @click="amountWithdrawal(item)">兑换</div>
                    <div v-if="item.activityProductType === 90 && item.productStatus === 10"
                        style="font-size: 14px;color: #17C2CF;">已兑换</div>
                </div>
            </div>
        </div>

        <!-- 加载更多提示 -->
        <div class="loading-more" v-if="loading">
            <van-loading size="16px">加载中...</van-loading>
        </div>
        <div class="no-more" v-if="noMore && activityData.length > 0">
            没有更多数据了
        </div>

        <!-- 发货信息弹窗 -->
        <van-popup v-model="expressShow" style="width:85vw;border-radius: 20px;padding:10px;">
            <div class="expressList">
                <span class="expressTitle">{{ checkDeliveryData.activityProductName }}</span>
                <div style="position:absolute;right:20px;" @click="expressClose()">X</div>
            </div>
            <div>
                <div class="sendGoods">奖品已发货</div>
                <div class="addressList">
                    <img :src="getExpressLogo(
                        checkDeliveryData.deliveryExpressId
                    )
                        " style="width: 22px; height: 22px; margin-right: 5px" />
                    <div></div>
                    {{ checkDeliveryData.deliveryExpressName }}
                    {{ checkDeliveryData.deliveryExpressNo }}
                    <span class="copyBtn" @click="
                        copyText(checkDeliveryData.deliveryExpressNo)
                        ">
                        复制
                    </span>
                </div>
                <div class="addList">
                    <van-icon name="location" />
                    <span style="font-size:14px;margin-left:5px;">送至 {{ checkDeliveryData.province }}{{
                        checkDeliveryData.city }}{{ checkDeliveryData.district }}{{ checkDeliveryData.address
                        }}</span>
                </div>
                <div style="margin:10px 15px;">
                    {{ checkDeliveryData.name }} {{ checkDeliveryData.phone }}
                </div>
            </div>
        </van-popup>
        <!-- 优惠券显示弹框 -->
        <van-popup v-model="couponShow" class="vanPop" style="width:85vw;border-radius: 20px;">
            <p class="closeBut" @click="close()">X</p>
            <div class="QRcode">
                <span class="qrName">{{ checkcouponList.activityProductName }}</span>
                <span style="font-size:18px;margin-top:10px" v-if="checkcouponList.couponPlatForm === 90">{{
                    checkcouponList.id }}</span>
                <span style="font-size:18px;margin-top:10px" v-else>{{ checkcouponList.couponCode }}</span>
                <div style="position:relative;">
                    <!-- 二维码成型内容 -->
                    <vue-qr v-if="checkcouponList.couponPlatForm === 90"
                        :text="`https://apph5web.wowotown.com/writeOff?id=${checkcouponList.id}`" :size="200"></vue-qr>
                    <!-- 大众点评/抖音/美团/小红书等 -->
                    <div style="text-align: center;margin-bottom:10px;">
                        {{ checkcouponList.couponPlatForm === 10 ? "大众点评" : checkcouponList.couponPlatForm === 20 ? "抖音"
                            :
                            checkcouponList.couponPlatForm === 30 ? "美团" : checkcouponList.couponPlatForm === 90 ? "窝窝投" :
                        "" }}
                    </div>
                </div>
                <span v-if="checkcouponList.longTermStatus === 10">有效期：长期</span>
                <span v-if="checkcouponList.longTermStatus === 20">{{
                    checkcouponList.startTime.slice(
                        0,
                        -9
                    )
                }}-{{
                        checkcouponList.endTime.slice(
                            0,
                            -9
                        )
                    }}</span>
                <p class="explain">
                    使用说明：
                    <span>
                        {{ checkcouponList.instructions }}
                    </span>
                </p>
            </div>
        </van-popup>
        <!-- end -->
    </div>
</template>

<script>
import vueQr from "vue-qr";
import { getRecordList, redeemNow } from '@/services/common'
import { Notify } from 'vant'
export default {
    components: {
        vueQr
    },
    data() {
        return {
            expressShow: false,
            activityData: [],
            picUrl: 'https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo',

            // 分页相关数据
            currentPage: 1,
            pageSize: 10,
            loading: false,
            noMore: false,
            total: 0,
            checkDeliveryData: {},
            couponShow: false,
            checkcouponList: {},
        };
    },
    created() {
        this.getActivityRecord();
    },
    methods: {
        amountWithdrawal(item) {
            const params = {
                activitySendId: item.id,//奖品发放ID
                userAddressId: item.userAddressId,
            }
            redeemNow(params).then((res) => {
                if (res.result === true) {
                    this.getActivityRecord();
                    Notify({ type: "success", message: "已发放" });
                } else {
                    Notify({
                        type: "danger",
                        message: res.message || "兑换失败",
                    });
                }
            })
        },
        goWithdrawal() {
            Notify({
                type: "warning",
                message: "请到“个人中心-钱包管理”提现",
            });
        },
        checkPoupon(item) {
            this.checkcouponList = item;
            this.couponShow = true;
        },
        checkList(item) {
            this.expressShow = true
            this.checkDeliveryData = item;
        },
        selectAddress(item) {
            this.$router.push({
                path: '/AddressList',
                query: {
                    id: item.id,
                    selectedAddressId: item.userAddressId
                }
            })
        },
        getActivityRecord(isLoadMore = false) {
            if (this.loading) return; // 防止重复请求
            this.loading = true;
            const params = {
                current: isLoadMore ? this.currentPage + 1 : 1,
                size: this.pageSize,
                activityTypes: 50,
                userId: this.$route.query.id,
                myActivityFlag: 1,
                activityProductTypes: '10,30,50,60,70,90'
            }

            getRecordList(params).then((res) => {
                const newData = res.data.records || [];
                this.total = res.data.total || 0;

                if (isLoadMore) {
                    // 上拉加载更多，追加数据
                    this.activityData = [...this.activityData, ...newData];
                    this.currentPage++;
                } else {
                    // 初始加载或下拉刷新，替换数据
                    this.activityData = newData;
                    this.currentPage = 1;
                }

                // 处理数据
                for (let i = 0; i < this.activityData.length; i++) {
                    if (this.activityData[i].activityProductType !== 70) {
                        this.activityData[i].showPopover = false;
                        this.activityData[i].productAmount = this.conversion(
                            this.activityData[i].activityProductAmount * 100
                        );
                        this.activityData[i].isShow = false;
                        this.activityData[i].isArea = false;
                        this.activityData[i].isAreaList = false;
                    }
                }

                // 判断是否还有更多数据
                this.noMore = this.activityData.length >= this.total;
            }).catch((error) => {
                console.error('获取数据失败:', error);
            }).finally(() => {
                this.loading = false;
            });
        },

        // 滚动事件处理
        handleScroll(event) {
            const { scrollTop, scrollHeight, clientHeight } = event.target;

            // 当滚动到底部附近时触发加载更多
            if (scrollTop + clientHeight >= scrollHeight - 50) {
                this.loadMore();
            }
        },

        // 加载更多数据
        loadMore() {
            if (this.loading || this.noMore) return;

            this.getActivityRecord(true);
        },

        // 下拉刷新（可选）
        onRefresh() {
            this.noMore = false;
            this.getActivityRecord(false);
        },

        // conversion 方法
        conversion(amount) {
            return (amount / 100).toFixed(2);
        },

        getExpressLogo(deliveryExpressId) {
            const expressMap = {
                1: "SF.png",
                2: "ZTO.png",
                10: "EMS.png",
                3: "YTO.png",
                4: "shentong.png",
                5: "Yunda.png",
                6: "BestExpress.png",
                8: "EMS.png",
                9: "otherExpress.png",
                // 可以根据需要添加更多快递公司
            };
            const logoFile =
                expressMap[deliveryExpressId] || "otherExpress.png";
            return require(`@/assets/express/${logoFile}`);
        },
        expressClose() {
            this.expressShow = false;
        },

        // 复制copyText
        copyText(text) {
            // 创建一个输入框元素
            const input = document.createElement("input");
            // 设置输入框的值为要复制的文本
            input.value = text;
            // 将输入框添加到页面
            document.body.appendChild(input);
            // 选择输入框中的文本
            input.select();
            // 对于iOS设备，设置选择范围
            input.setSelectionRange(0, input.value.length);
            // 尝试执行复制命令
            try {
                document.execCommand("copy");
                Notify({ type: "success", message: "复制成功" });
            } catch (err) {
                Notify({ type: "danger", message: "复制失败" });
                console.error("复制失败:", err);
            }
            // 移除输入框
            document.body.removeChild(input);
        },

        close() {
            this.couponShow = false;
        },
    },
};
</script>

<style lang="less" scoped>
.recordList {
    padding: 10px;
    height: 97vh;
    overflow-y: scroll;
    background-color: #F7F8FC;
}

.record {
    margin: 15px 0;
}

.itemRecord {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    padding: 8px 6px;
    border-radius: 12px;
}

.nameList {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;
    flex: 1;
    /* 添加这行，让nameList占据剩余空间 */
    min-width: 0;
    /* 添加这行，允许内容收缩 */
}

.name {
    font-size: 16px;
    font-weight: bold;
    white-space: wrap;
    max-width: 156px;
    /* 根据实际需要调整最大宽度 */
    flex-shrink: 1;
    /* 允许收缩 */
}

.date {
    font-size: 14px;
}

.status {
    font-weight: 500;
    font-size: 12px;
    color: #17C2CF;
    background-color: #DCF6F8;
    padding: 3px 5px;
    margin-left: 5px;
    border-radius: 5px;
}

.logoImg {
    height: 45px;
    width: 45px;
    border-radius: 5px;
    object-fit: cover;
}

.buts {
    font-size: 13px;
    align-items: center;
    background-color: #17C2CF;
    color: #ffffff;
    padding: 5px 8px;
    border-radius: 5px;
    text-align: center;
}

.expressList {
    display: flex;
    justify-content: center;
    align-items: center;

    .expressTitle {
        font-weight: 500;
        font-size: 19px;
        color: #333333;
        margin: 10px 0;
    }
}

.sendGoods {
    background: linear-gradient(270deg, #FF9732 0%, #FF3E54 100%);
    border-radius: 4px;
    width: 90px;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    margin: 0 auto;
    text-align: center;
    align-items: center;
    padding: 2px;
    line-height: 24px;
}

// 快递列表
.addressList {
    display: flex;
    align-items: center;
    margin: 10px 0;
}

.copyBtn {
    color: #165dff;
    margin-left: 10px;
    font-size: 14px;
    margin-top: -5px;
}

// 分页相关样式
.loading-more {
    text-align: center;
    padding: 20px;
    color: #999;
}

.no-more {
    text-align: center;
    padding: 20px;
    color: #999;
    font-size: 14px;
}

.QRcode {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.closeBut {
    position: absolute;
    right: 20px;
    top: 0px;
}

.explain {
    padding: 0 5px;
    font-size: 14px;
}

.no-data-text {
    text-align: center;
    margin-top: 30px;
}
</style>
